<template>
  <div>
    <b-btn-toolbar v-if="editMode">
      <autocomp
        v-bind:value="searchFor"
        @input="setPlace($event)"
        v-bind:datasource="places"
        v-on:filter="getPlaces($event)"
      ></autocomp>
      <b-button class="input-group-text">
        <!-- <i class="fa fa-plus" @click="newPlace()" title="Ny adress"></i> -->
        <b-icon-plus-square @click="newPlace()" title="Ny adress" />
      </b-button>
    </b-btn-toolbar>
    <b-card v-if="place">
      {{ place.Name }}
      <div class="float-right" v-if="editMode">
        <i
          class="fa fa-edit fa-xs mt-4"
          @click="changePlace()"
          title="Ändra adress"
        ></i>
      </div>
      <br />
      {{ place.Street }}
      <br />
      {{ place.Street2 }}
      <br />
      {{ place.CountryCode }}-{{ place.PostCode }}&nbsp;{{ place.City }}
      <i
        class="fa fa-map fa-xs mt-4"
        @click="showOnMap"
        title="Visa på karta"
      ></i>
      <br />
      <div>
        <i>{{ getContact() }}</i>
      </div>
      <i>{{ place.Comment }}</i>
    </b-card>

    <b-modal title="Adress" v-model="addNewMode" @ok="setNewPlace()">
      <b-card v-if="addNewMode">
        <b-row>
          <b-col>
            <b-check v-model="chkPublic">Spara till adressregister</b-check>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input v-model="editPlace.Name" title="Namn" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input v-model="editPlace.Street" title="Adress1" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input v-model="editPlace.Street2" title="Adress2" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            <b-form-input v-model="editPlace.CountryCode"></b-form-input>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="editPlace.PostCode"></b-form-input>
          </b-col>
          <b-col cols="7">
            <b-form-input v-model="editPlace.City"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Kontaktuppgifter:</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              v-model="editPlace.ContactName"
              placeholder="Kontaktnamn"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              v-model="editPlace.ContactPhone"
              placeholder="Telefonnr"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              v-model="editPlace.ContactEmail"
              placeholder="E-post"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Notering:</label>
            <b-form-input
              v-model="editPlace.Comment"
              placeholder="Notering"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<script>

import autocomp from "./../../components/autocomp";
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "placedetails",
  props: { place: Object, editMode: false, partyid: null },
  components: { autocomp },
  data() {
    return {
      searchFor: null,
      places: [],
      addNewMode: false,
      editPlace: null,
      chkPublic: true,
    };
  },
  methods: {
    
    getContact() {
      var res = [
        this.place.ContactName,
        this.place.ContactPhone,
        this.place.ContactEmail,
      ];
      return res.join(" ").trim();
    },
    showOnMap() {
      var addr = [
        this.place.Name,
        this.place.Street,
        this.place.Street2,
        this.place.PostCode,
        this.place.City,
      ];
      window.open("http://maps.google.se/?q=" + addr.join(","));
    },
    getPlaces(ev) {
      // console.log("getPlaces:" + ev);
      var flt = ev;
      //this.places.push({ text: "Ny", id: 44 });
      if (flt && flt.length > 0) {
        var p = api.params({ partyId: this.partyid, filter: flt });
        api.get("/api/apiplace/GetPlaces?" + p).then((res) => {
          this.places = res.data;
        });
      }
    },
    setPlace(ev) {
      // console.log("setPlace:" + ev);
      if (ev > 0) {
        var p = api.params({ placeId: ev });
        api.get("/api/apiplace/GetPlace?" + p).then((res) => {
          if (res.data.PlaceID > 0) {
            this.place = res.data;
            this.searchFor = null;
            this.$emit("input", this.place);
          }
        });
      }
    },
    newPlace() {
      this.editPlace = {
        PartyID: this.partyid,
        CountryCode: (this.place) ? this.place.CountryCode : 'SE',
      };
      this.chkPublic = true;
      this.addNewMode = true;
    },
    setNewPlace() {
      this.addNewMode = false;
      this.editPlace.DBStatus_ID = this.chkPublic ? "1" : "0";
      api.post("/api/apiplace/SavePlace", this.editPlace).then((res) => {
        console.log(res);
        this.setPlace(res.data.PlaceID);
      });
    },
    changePlace() {
      this.editPlace = this.place;
      this.chkPublic = true;
      this.addNewMode = true;
    },
  },
};
</script>

<style>
</style>